// @flow strict

// TODO TRIP-3319: Saves icons are changing to hearts. If it rolls out, this package and all
// components in the package should be renamed to SavesIcon along with any references to the
// name bookmark to make it more generic. Also remove any feature-gated logic that chooses
// between bookmarks and hearts. The scope of this may extend outside this package.
// See ticket for more details.

export { default as BookmarkIcon } from './BookmarkIcon';
export { default as EncircledBookmarkIcon } from './EncircledBookmarkIcon';
export type { BookmarkStyle, BookmarkSize } from './BookmarkIcon';
export type { BookmarkTextStyle } from './BookmarkIcon';
